// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import ElementUI from 'element-ui';
import "@/assets/style/text/text.css";
// import './plugins/axios'
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import gaoMap from './utils/gaoMap.js'
import lflexibl from './lflexibl/index'
import Viewers from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Swiper from 'swiper';
import * as basePath from './api/basePath'
// import './plugins/axios'
import VueI18n from 'vue-i18n'
import lottie from 'vue-lottie';
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)
Vue.component('lottie', lottie)
Vue.use(VueI18n)
import { HappyScroll } from 'vue-happy-scroll'
// 引入css
import 'vue-happy-scroll/docs/happy-scroll.css'
Vue.component('happy-scroll', HappyScroll)
// Vue.prototype.$gaoMap = gaoMap

//by yang
// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'
import { swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.prototype.$axios = axios
Vue.prototype.$basePath = basePath

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {

    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
  if (!to.matched.some(r => r.meta.requireAuth)) {

    if (sessionStorage.getItem('city')) {
      next()
    } else {
      const path = to.path
      next({
        path: '/login',
        query: { redirect: path }
      })
    }
  } else {
    next()
  }
})
Viewers.setDefaults({
  'inline': false,
  'button': true, // 右上角按钮
  'navbar': false, // 底部缩略图
  'title': false, // 当前图片标题
  'toolbar': true, // 底部工具栏
  'tooltip': true, // 显示缩放百分比
  'movable': true, // 是否可以移动
  'zoomable': true, // 是否可以缩放
  'rotatable': false, // 是否可旋转
  'scalable': false, // 是否可翻转
  'transition': true, // 使用 CSS3 过度
  'fullscreen': true, // 播放时是否全屏
  'keyboard': true, // 是否支持键盘
  'url': 'images'
})

Vue.use(Viewers)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.use(lflexibl)



// WEBPACK FOOTER //
// ./src/main.js